import type { ProductListItem } from 'product-list/types/ProductsList'

export enum ModuleTag {
	Banner = 'banner',
	M1 = 'M1',
	M2 = 'M2',
	M3 = 'M3',
	M4 = 'M4',
	M5 = 'M5',
	M6 = 'M6',
}

interface Banner {
	tag: ModuleTag.Banner
	title: string
	imageUrl: string
}

interface M1Module {
	tag: ModuleTag.M1
	product: ProductListItem
}

interface M2Module {
	tag: ModuleTag.M2
	products: ProductListItem[]
}

interface M3Module {
	tag: ModuleTag.M3
	products: ProductListItem[]
}

interface M4Module {
	tag: ModuleTag.M4
	products: ProductListItem[]
}

interface M5Module {
	tag: ModuleTag.M5
	product: ProductListItem
}

interface M6Module {
	tag: ModuleTag.M6
	products: ProductListItem[]
}

export type Module =
	| Banner
	| M1Module
	| M2Module
	| M3Module
	| M4Module
	| M5Module
	| M6Module
